import React from 'react'
import './ContactContent.scss'

import location from '../../assets/Pictures/LocationRed.svg'
import whatsapp from '../../assets/Pictures/whatsappGreen.svg'
import tell from '../../assets/Pictures/tellRed.svg'
import email from '../../assets/Pictures/mailRed.svg'
import informationIcon from '../../assets/Pictures/info.svg'

export default function ContactContent() {
  return (
    <div className='contactContent'>
      <div className="container">
        <div className="row">
          <div className="address">
            <img className='informationIcon' src={informationIcon} alt="informationIcon" />
            <div className="addressRow addressRowLine">
              <img src={location} alt="location" />
                Maltepe Mah, Eski Cirpici Yolu sk. No: 3B IC Kapi No: 
                48 Zeytinburnu
                / Istanbul . Turkey
            </div>
            <div className="addressRow">
              <img src={whatsapp} alt="whatsapp" />
              +90 539 680 2900
            </div>
            <div className="addressRow addressRowLine">
              <img src={tell} alt="tell" />
              +90 539 938 8835
            </div>
            <div className="addressRow">
              <img src={email} alt="email" />
              info@globalenergyinvestmentco.com
            </div>
          </div>
          <div className="address">
            <img className='informationIcon' src={informationIcon} alt="informationIcon" />
            <div className="addressRow addressRowLine">
              <img src={location} alt="location" />
              No.44, Building 533, AL Maha St, AL khuwair, Muscat
              Sultanate of OMAN
            </div>
            <div className="addressRow">
              <img src={whatsapp} alt="whatsapp" />
              +968 9938 3841
            </div>
            <div className="addressRow addressRowLine">
              <img src={whatsapp} alt="whatsapp" />
              +968 9943 4964
            </div>
            <div className="addressRow">
              <img src={email} alt="email" />
              info@globalenergyinvestmentco.com
            </div>
          </div>
        </div>
        <div className="row">
          <div className="address">
            <img className='informationIcon' src={informationIcon} alt="informationIcon" />
            <div className="addressRow addressRowLine">
              <img src={location} alt="location" />
              Alb-Schweizer Zer 2, 24119 Kronshagen, Germany. EU
            </div>
            <div className="addressRow addressRowLine">
              <img src={tell} alt="tell" />
              +49 173 752 6968
            </div>
            <div className="addressRow">
              <img src={email} alt="email" />
              info@globalenergyinvestmentco.com
            </div>
            <div className="addressRow">
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
